import { createFileRoute, redirect } from '@tanstack/react-router';
import { CUSTOMER_DATA_TABS } from 'cpool-constants';
import { z } from 'zod';

import { CUSTOMER_DATA_TAB_PATHS } from '~/features/leadDetails/constants/tabPaths';
import { isBuildingDescriptionStepPath, isCustomerDataTabPath } from '~/features/leadDetails/utils/tabPaths';

export const Route = createFileRoute('/_app/leads_/details/$leadId/customer-data/$customerTab/$realEstateId/$step')({
    beforeLoad: ({ params }) => {
        const validRealEstateId = z.string().uuid().safeParse(params.realEstateId).success;
        const validStep = isBuildingDescriptionStepPath(params.step);
        const isRealEstateTab = params.customerTab === CUSTOMER_DATA_TAB_PATHS[CUSTOMER_DATA_TABS.REAL_ESTATE];

        if (!isRealEstateTab || !validRealEstateId || !validStep) {
            const customerTab = isCustomerDataTabPath(params.customerTab)
                ? params.customerTab
                : CUSTOMER_DATA_TAB_PATHS[CUSTOMER_DATA_TABS.PERSONAL_DATA];
            throw redirect({
                params: {
                    customerTab,
                    leadId: params.leadId,
                },
                replace: true,
                search: true,
                to: '/leads/details/$leadId/customer-data/$customerTab',
            });
        }
    },
});
